import { FC } from 'react';

import styles from './NoSessionMessage.module.scss';

export const NoSessionMessage: FC = () => {
  const message = 'Everything is ready for you to get started.';

  return (
    <div>
      <div className={styles.emptyStateMessage}>{message}</div>
      <div className={styles.activitiesLink}>
        Can’t see your activity bookings? Click{' '}
        <a href="https://activities.bookpebble.co.uk/profile" target="_blank">
          HERE
        </a>
      </div>
    </div>
  );
};
